import { render, staticRenderFns } from "./ColumnItemPhone.vue?vue&type=template&id=6868bc9c&scoped=true&"
import script from "./ColumnItemPhone.vue?vue&type=script&lang=js&"
export * from "./ColumnItemPhone.vue?vue&type=script&lang=js&"
import style0 from "./ColumnItemPhone.vue?vue&type=style&index=0&id=6868bc9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6868bc9c",
  null
  
)

export default component.exports